import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Style, StatusBar } from '@capacitor/status-bar';
import { AlertController, AlertOptions, LoadingController, LoadingOptions, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {
  private isLoading:boolean = false;
  private loading:any = null;

  constructor(
    private loadingCtrl:LoadingController,
    private alertCtrl:AlertController,
    private toastCtrl:ToastController
  ) { }

  async showLoading(message:string = ''):Promise<void> {
    if(this.isLoading) return;
    this.isLoading = true;
    const option: LoadingOptions = {
      cssClass:"custom_loading",
      showBackdrop:true,
      translucent:true,
      animated:true,
      mode:"ios"
    };
    if(message) option.message = message;
    this.loading = await this.loadingCtrl.create(option);
    await this.loading.present();
  }

  async dismissLoading():Promise<void> {
    try {
      await this.loading?.dismiss();
      this.isLoading = false
    } catch (error) {
      this.isLoading = false;
    }
  };

  async presentToast(message:string,error:boolean = true):Promise<void> {
    const toast = await this.toastCtrl.create({
      header:error ? "خطأ" : "تم",
      message,
      mode:"md",
      duration:2000,
      // cssClass:error ? "toast-error" : "toast-success",
      icon:error ? "close-circle" : "checkmark-circle",
      position:"bottom",

      buttons:[
        {
          icon:"close",
          role:"cancel"
        }
      ]
    });
    await toast.present();
  };



  async confirmAlert(alertOption?:AlertOptions):Promise<boolean> {
    const options:AlertOptions = {
      header:alertOption?.header || "تأكيد العملية",
      message: alertOption?.message || "هل انت متأكد من تنفيذ العملية ؟",
      mode:"ios",
      buttons:[
        {
          text:"الغاء",
          role:"cancel"
        },
        {
          text:"تأكيد",
          role:"confirm"
        },
      ],
    };

    const alert = await this.alertCtrl.create(options);
    await alert.present();
    const data = await alert.onDidDismiss();
    return data.role == "confirm"
  }

  async setStatusBar(style: Style, color: string):Promise<void> {

    const platform = Capacitor.getPlatform();
    if(!["android", "ios"].includes(platform)) return

    if (platform == 'android') {
      await StatusBar.setBackgroundColor({ color });
      await StatusBar.setOverlaysWebView({ overlay: false })
    }

    await StatusBar.setStyle({ style });

  }

}
